module.exports = "/static/assets/a6cebfe99bad7b01f59b85998cbc4628.svg";